import { Component, ElementRef, ViewChild } from '@angular/core';
import { CustomizationFrameworkService } from '../../../../shared-modules/customization-framework/customization-framework.service';
import { LoginService } from '../../../../shared-modules/login/login.service';
import { YearService } from '../../../year/year.service';
import { DataDefControl } from '../data-def-control.directive';

@Component({
  selector: 'data-def-button-list',
  templateUrl: './data-def-button-list.component.html',
  styleUrls: ['./data-def-button-list.component.css']
})
export class DataDefButtonListComponent extends DataDefControl {

  private _controlRef: ElementRef;
  get controlRef(): ElementRef {
    return this._controlRef;
  }
  @ViewChild('control', { read: ElementRef }) set controlRef(value: ElementRef) {
    this._controlRef = value;
    this.controlEmitter.emit(value);
  }

  constructor(
    customizationFrameworkService: CustomizationFrameworkService,
    yearService: YearService,
    loginService: LoginService
  ) {
    super(customizationFrameworkService, yearService, loginService);
  }


}
